@if ((kydSmartphoneEligible$ | async) && !(showKYDManageEnrollmentDuringMigration$ | async)) {
  <div>
    <h4 class="heading-sub-section">KnowYourDrive Smartphone Program</h4>
    <div class="row">
      <div class="column twelve md-nine">
        <p>
          Drive safer and save money. The KnowYourDrive Smartphone Program helps you learn safe
          driving habits and rewards you with a discount on your car insurance. It's quick and easy
          to get started! Be sure all drivers have a unique phone number and an Apple or Android
          smartphone for downloading the app.
        </p>
        <p class="pad-top-10">
          Have questions or want more info? Check out our <a dsRouterLink="/faq">FAQ</a> or the
          <a href="http://www.knowyourdrive.com" target="_blank">KnowYourDrive</a> Smartphone
          Program page on our website.
        </p>
      </div>
      <div class="column twelve md-three text-right">
        <button ds-button type="button" (click)="enroll()">
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
}
@if (showKYDManageEnrollmentDuringMigration$ | async) {
  <div>
    <h4 class="heading-sub-section">KnowYourDrive Smartphone Program</h4>
    <div class="row">
      <div class="column twelve md-nine">
        <p>
          Drive safer and save money. The KnowYourDrive Smartphone Program helps you learn safe
          driving habits and rewards you with a discount on your car insurance. It's quick and easy
          to get started! Be sure all drivers have a unique phone number and an Apple or Android
          smartphone for downloading the app.
        </p>
        <p class="pad-top-10">
          Have questions or want more info? Check out our <a dsRouterLink="/faq">FAQ</a> or the
          <a href="http://www.knowyourdrive.com" target="_blank">KnowYourDrive</a> Smartphone
          Program page on our website.
        </p>
      </div>
      <div class="column twelve md-three text-right">
        <button ds-button type="button" (click)="enroll()">
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
}
